s4 = () ->
  Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1)

exports.generateGuid = () ->
  s4() + s4() + '-' + s4() + '-' + s4()



// WEBPACK FOOTER //
// ./src/helpers/guid.coffee